import { defineStore } from 'pinia'
import { BASE_URL } from '@constants'

export const useGlobalStore = defineStore('global', {
	state: () => {
		return {
			mobile: false,
			cart: false,
			modal: {
				name: null,
				payload: null,
			},
			hero: {},
			socials: [],
			faqs: [],
			team: [],
			contacts: [
				{
					icon: 'fab-sharp fa-regular fa-envelope-open',
					label: 'info@gardenmother.co',
				},
			],
			wholesalePartners: [],
			deliveryPartners: [],
		}
	},
	actions: {
		toggleMobile(delta) {
			delta != null ? (this.mobile = delta) : (this.mobile = !this.mobile)
		},
		setup() {
			this.getHero()
			this.getSocials()
			this.getFAQs()
			this.getTeam()
			this.getWholesalePartners()
			this.getDeliveryPartners()
		},
		toggleCart(delta) {
			delta != null ? (this.cart = delta) : (this.cart = !this.cart)
		},
		//
		getHero() {
			return axios
				.get('/api/hero')
				.then((hero) => {
					this.hero = hero.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getSocials() {
			return axios
				.get('/api/socials')
				.then((socials) => {
					this.socials = socials.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getFAQs() {
			return axios
				.get('/api/faqs')
				.then((faqs) => {
					this.faqs = faqs.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getTeam() {
			return axios
				.get('/api/team')
				.then((team) => {
					this.team = team.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getWholesalePartners() {
			return axios
				.get('/api/wholesale-partners')
				.then((wholesalePartners) => {
					this.wholesalePartners = wholesalePartners.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getDeliveryPartners() {
			return axios
				.get('/api/delivery-partners')
				.then((deliveryPartners) => {
					this.deliveryPartners = deliveryPartners.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		openModal(modal) {
			this.modal = {
				name: modal[0],
				payload: modal[1],
			}
		},
		closeModal() {
			this.modal = {
				name: null,
				payload: null,
			}
		},
	},
})
